/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.0.0
 */

import { ICommonErrorTranslation } from '../../types/common';

export const initTranslationError: ICommonErrorTranslation = {
    codes: {},
    defaultMessage: 'Something went wrong',
    forbidden: {
        text: '',
        title: '',
    },
    notFound: {
        text: '',
        title: '',
    },
    ui: {
        text: '',
        title: '',
    },
};
